import { render, staticRenderFns } from "./DSCopyIcon.vue?vue&type=template&id=7b0f247d&scoped=true&"
import script from "./DSCopyIcon.vue?vue&type=script&lang=js&"
export * from "./DSCopyIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0f247d",
  null
  
)

export default component.exports